import React, { FunctionComponent } from "react";
import { BioProps } from "../../interfaces/interfaces";

const Bio: FunctionComponent<BioProps> = ({ data }) => {
  const { name, position, company, bio } = data;

  return (
    <div className="bio-container">
      <h2>{name}</h2>
      <h4>{position}</h4>
      <h4>{company}</h4>
      {bio ? (
        <div
          dangerouslySetInnerHTML={{
            __html: `${bio}`,
          }}
        ></div>
      ) : (
        <div style={{ textTransform: "uppercase" }}>Bio Coming Soon!</div>
      )}
    </div>
  );
};

export default Bio;
